const TextInput = ({
  label,
  required,
  onTextChange,
  value,
  placeholder,
  classes,
  disabled,
}: {
  label: string;
  required?: boolean;
  onTextChange?: (text: string) => void;
  value: string;
  placeholder?: string;
  classes?: string;
  disabled?: boolean;
}) => {
  return (
    <div className={`mb-6 ${classes}`}>
      <label htmlFor="item-name" className="font-display text-dark-navy mb-2 block dark:text-white">
        {label}
        {required && <span className="text-red">*</span>}
      </label>
      <input
        type="text"
        id="item-name"
        className="dark:bg-dark-navy w-full rounded-lg border-light-grey focus:border-grey hover:border-grey  dark:text-white ring-0 focus:ring-0"
        placeholder={placeholder}
        value={value}
        required
        onChange={(e) => onTextChange && onTextChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
};

export default TextInput;
